 // LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Svg_mail_box from '../../img/dashboard/mail_box.svg';
// @ts-ignore
import {group_notifications, format_notification_time, i_notification}
    from './utils/notifications';
import {App_context} from 'hola_app_context';
import {Notification_item} from './notifications_item';
import {Notification_skeleton_loader}
    from '../../../../oculus/pub/ui/dashboard/notification_skeleton_loader';
import {No_account} from './no_account';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import etask from 'zetask';
import styles from '../../pages/toolip.io/dashboard.module.less';

interface i_notifications {
    auth: any;
    notifications: i_notification[];
    loading: boolean;
    handle_remove: (notification_id: string) => void;
    only_unread_notification_ids: string[];
}
export const Notifications = (
    {
        auth,
        notifications,
        loading,
        handle_remove,
        only_unread_notification_ids
    }: i_notifications)=>{
    const {user} = useContext(App_context);
    const {theme} = useContext(Settings_context);
    useEffect(()=>{
        if (!user)
            return;
        const mark_notifications_read = ()=>etask(function*(){
            try {
                if (only_unread_notification_ids.length)
                {
                    yield fetch('/api/mark_notifications_read', {
                        method: 'PUT',
                        body: {ids: only_unread_notification_ids},
                    });
                }
            } catch(e){
                console.error('Failed to fetch notifications:', e);
            }
        });
        mark_notifications_read();
        return ()=>{
            mark_notifications_read();
        };
    }, [user, only_unread_notification_ids]);
    if (!notifications.length && !loading)
    {
        return <div className={styles.empty_notification}>
          <h4 className={styles.mb32}>Notifications</h4>
          <div className={styles.no_notifications_line}>
            <Svg_mail_box width={152} height={127}/>
            <p className={cn(theme.p2, theme.med, theme.color_n700)}>
              You're all caught up. No new notifications at the moment!</p>
          </div>
        </div>;
    }
    const {
        today,
        last_7_days,
        last_month
    } = group_notifications(notifications);
    const render_group = (title: string, items: i_notification[])=>{
        if (!items.length)
            return null;
        return <>
          <p className={cn(styles.paragraph_title,
            theme.color_n400, theme.p14, theme.med)}>{title}</p>
          <div className={styles.notifications}>
            {items.map(n=><Notification_item
              key={n._id}
              title={n.title}
              message={n.message}
              type={n.type}
              time={format_notification_time(n.time)}
              button_text={n.button_text}
              button_link={n.button_link}
              read={n.read}
              icon_url={n.icon_url}
              variant={n.variant}
              open_in_new_tab={n.open_in_new_tab}
              on_delete={()=>handle_remove(n._id)}/>
          )}
          </div>
        </>;
    };
    return <div className={styles.notification_container}>
      <h5 className={cn(styles.title, theme.bold)}>Notifications</h5>
      {user ? <Notification_skeleton_loader
        is_loading={loading} items={4} site='toolip'>
        <>
          {render_group('Today', today)}
          {render_group('Last 7 days', last_7_days)}
          {render_group('Last months', last_month)}
        </>
      </Notification_skeleton_loader> : <No_account auth={auth}/>}
    </div>;
};
